import intlTelInput from 'intl-tel-input'
import emailMisspelled, {top100} from "email-misspelled"

import {dynamicForm, injectCsrf} from "../dynamicForm";
import {setPrefillFormData, initializeDataPrefill, formsApi, processOtpUrlParam} from "../formPrefill"
import {
  chooseSelectOption,
  chooseRadioOption,
  getConditionalRedirectUrl,
  getFinalRedirectOverwrite,
  handleImmediateRedirectBasedOnFormValues,
  lockSubmit,
  unlockSubmit,
  addPartnerParameterToUrlParams,
  addQueryStringToUrl,
  getInputValue,
  getDefaultFormParams,
  filterStepsInFormNavigation,
  filterStepBarsInForm,
  parseStepsHidingConfig,
  checkIfUserIsEligible,
  storeDataStorageBeforeRedirect, getDataStorageAfterRedirect
} from "../forms";
import {cohortSelectorSupport} from "../cohortSelectorSupport";
import {accMarketSelectorSupport} from "../accMarketSelectorSupport";
import {
  initPhoneInputs,
  loadLibPhone,
  checkEmailInputValidation,
  checkPhoneInputValidation,
  setAutoSuggestionToInput
} from "../formInputs";

window.fullstackacademy = window.fullstackacademy || {};

Object.assign(window.fullstackacademy, {
  dynamicForm,
  injectCsrf,
  getConditionalRedirectUrl,
  setPrefillFormData,
  initializeDataPrefill,
  processOtpUrlParam,
  formsApi,
  getFinalRedirectOverwrite,
  handleImmediateRedirectBasedOnFormValues,
  cohortSelectorSupport,
  accMarketSelectorSupport,
  initPhoneInputs,
  lockSubmit,
  unlockSubmit,
  chooseSelectOption,
  chooseRadioOption,
  addPartnerParameterToUrlParams,
  addQueryStringToUrl,
  getInputValue,
  getDefaultFormParams,
  filterStepsInFormNavigation,
  filterStepBarsInForm,
  parseStepsHidingConfig,
  checkIfUserIsEligible,
  loadLibPhone,
  checkEmailInputValidation,
  checkPhoneInputValidation,
  storeDataStorageBeforeRedirect,
  getDataStorageAfterRedirect,
  setAutoSuggestionToInput
})

// attach intlTelInput to the window object
window.intlTelInput = intlTelInput

//attach emailChecker to the window object
window.emailChecker = emailMisspelled({domains: top100})